import React, { PureComponent } from 'react';
import { installmentBannerLoadFinished, installmentBannerListLoaded } from '@wix/bi-logger-payments-data/v2';
import { type BiLogger } from '../../utils/biLogger';
import { type ClientBnplMethodInfo } from '../../types/ClientBnplMethodInfo';
import { useBiLogger } from '../../utils/biLogger/useBiLogger';
import { PaymentMethodsListView } from './view';
import { getBiOfferId, getPaymentProvider, sortPaymentMethodsByRank } from './utils';

interface PaymentMethodsListControllerProps {
  bnplMethods: ClientBnplMethodInfo[];
  biLogger?: BiLogger;
}

export interface PaymentMethodsListState {
  sortedBnplMethods: ClientBnplMethodInfo[];
  biOfferId: string;
  paymentProvider: string;
}

class PaymentMethodsListController extends PureComponent<PaymentMethodsListControllerProps, PaymentMethodsListState> {
  state: PaymentMethodsListState = {
    sortedBnplMethods: [],
    biOfferId: '',
    paymentProvider: '',
  };

  static getDerivedStateFromProps(props: PaymentMethodsListControllerProps) {
    const sortedBnplMethods = sortPaymentMethodsByRank(props.bnplMethods);
    return {
      sortedBnplMethods,
      biOfferId: getBiOfferId(sortedBnplMethods),
      paymentProvider: getPaymentProvider(sortedBnplMethods),
    };
  }

  componentDidMount() {
    this.props.biLogger?.report(
      installmentBannerLoadFinished({
        offerId: this.state.biOfferId,
        paymentProvider: this.state.paymentProvider,
      }),
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.biOfferId !== prevState.biOfferId) {
      this.props.biLogger?.report(
        installmentBannerListLoaded({
          offerId: this.state.biOfferId,
          paymentProvider: this.state.paymentProvider,
        }),
      );
    }
  }

  render() {
    const { sortedBnplMethods } = this.state;

    if (!sortedBnplMethods.length) {
      return null;
    }

    return <PaymentMethodsListView bnplMethods={sortedBnplMethods} />;
  }
}

export const PaymentMethodsList = (props: PaymentMethodsListControllerProps) => {
  const biLogger = useBiLogger();

  return <PaymentMethodsListController biLogger={biLogger} {...props} />;
};
